export default {
  componentName: 'Leaderboard',
  exampleImgUrl:
    'https://drive.google.com/open?id=1lIR3U4UNzF2CTLSItLzjYu5TI2_SGZYL',
  nickname: 'Leaderboard',
  pageList: [
    'https://develop.bassmaster.com/leaderboard/tournaments/2018-toyota-bassmaster-angler-year-championship',
  ],
  renderId: 'react-app--leaderboard',
};
